/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Amount_UnreadableInputs */



/**
* | output |
* | --- |
* | "could not be read" |
*
* @param {Receipt_Amount_UnreadableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_amount_unreadable = /** @type {((inputs?: Receipt_Amount_UnreadableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Amount_UnreadableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("nicht lesbar")
	return /** @type {LocalizedString} */ ("could not be read")
});